// Market resolution hero — view event. Fires once per hero mount when a
// resolved market's full-width hero becomes visible. Distinct from
// `market_detail_viewed` (the page-level view) so the funnel can attribute
// the resolution-specific surface separately from the rest of the page.

import type { EventDefinition } from './navigation';

export type MarketResultViewedUserOutcome = 'winner' | 'loser' | 'even' | 'no_position';
export type MarketResultViewedStage = 'computing_claims' | 'grace_period' | 'claims_ready';

// Use `type` (not `interface`) so the payload satisfies the
// `Record<string, unknown>` constraint that `EventDefinition` enforces —
// same convention as every other event payload in `src/events/`.
export type MarketResultViewedProperties = {
  marketPubkey: string;
  /** Null when the viewer has no connected wallet (lurker session). */
  walletPubkey: string | null;
  userOutcome: MarketResultViewedUserOutcome;
  stage: MarketResultViewedStage;
};

export const MARKET_RESULT_VIEWED: EventDefinition<MarketResultViewedProperties> = {
  name: 'market_result_viewed',
};
